import { compact } from '.';
import { normalizeQueryString } from './querystring';
import getRegionByCodes from './getRegionByCodes';

export default function createAreaKey(options) {
  const { countyId, regionCode, countryCode } = options;
  let { area } = options;

  // If the 'area' is just the name of the region, remove it because it's redundant
  if (regionCode) {
    const region = getRegionByCodes(regionCode, countryCode);
    if (region?.name === area) {
      area = undefined;
    }
  }

  return normalizeQueryString(compact({ area, countyId, regionCode, countryCode }));
}
